









































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Terms extends Vue {
  getOrigin() {
    return window.location.origin;
  }

  getHost() {
    return window.location.host;
  }
}
